/** True on macOS/iOS, where the command-palette shortcut is ⌘K rather than Ctrl K. */
export function isApplePlatform(
  nav: Pick<Navigator, "platform" | "userAgent"> | undefined = typeof navigator === "undefined" ? undefined : navigator,
): boolean {
  if (!nav) return false;
  const uaPlatform = (nav as Navigator & { userAgentData?: { platform?: string } }).userAgentData?.platform;
  return /mac|iphone|ipad|ipod/i.test(uaPlatform ?? nav.platform ?? "") || /Mac OS X|iPhone|iPad/.test(nav.userAgent ?? "");
}

/** The label for the global-search shortcut on this platform. */
export function searchShortcutLabel(nav?: Pick<Navigator, "platform" | "userAgent">): string {
  return isApplePlatform(nav ?? (typeof navigator === "undefined" ? undefined : navigator)) ? "⌘K" : "Ctrl K";
}
